import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import FlylineObject from "../objects/FlylineObject";
import type { FlylineMapObject, MapLayerProps } from "../types";

type FlylinesLayerProps = MapLayerProps<FlylineMapObject>;

const FlylinesLayer = ({
    id,
    items,
    selectedIds,
    onItemClick,
    onItemHover,
    onItemLeave,
}: FlylinesLayerProps) => {
    const { items: layerItems } = useMapLayer({ items, selectedIds });
    const baseObjects = useMemo(
        () =>
            layerItems.map((item) => (
                <FlylineObject
                    key={item.id}
                    item={item}
                    layerId={id}
                    selected={selectedIds?.has(item.id) ?? false}
                    onItemClick={onItemClick}
                    onItemHover={onItemHover}
                    onItemLeave={onItemLeave}
                />
            )),
        [id, layerItems, onItemClick, onItemHover, onItemLeave, selectedIds],
    );

    return <pixiContainer label="flylines-layer">{baseObjects}</pixiContainer>;
};

export default FlylinesLayer;
